import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { AccountTemplate, AccountTemplateSaveResponse } from '../../../types/AccountTemplate';
import { mutationKeys } from '../mutationKeys';

export const updateAccountTemplate = async (uuid: string, formData: AccountTemplateSaveResponse) => {
  const response = await CustomAxios.put(`account_templates/${uuid}`, formData);
  return response.data;
};

interface UseUpdateAccountTemplateFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUpdateAccountTemplate({ uuid, onSuccessCallback }: UseUpdateAccountTemplateFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateAccountTemplate],
    mutationFn: (formData: AccountTemplateSaveResponse) => updateAccountTemplate(uuid, formData),
    onSuccess: (data: AccountTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allAccountTemplates, data.uuid],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as AccountTemplate;
        queryClient.setQueryData([queryKeys.allAccountTemplates, template.uuid], template);
      }
    },
  });
}
